import { createFileRoute } from '@tanstack/react-router'
import { ProcurementLaneScreen } from '../features/ledger/procurement-lane'

// The Ledger's Procurement lane, a sibling of /ledger (the trailing underscore un-nests it from the ledger screen).
export const Route = createFileRoute('/ledger_/procurement')({
  component: ProcurementLaneScreen,
})
